import { render, staticRenderFns } from "./TemplateInfoModal.vue?vue&type=template&id=9377b174&scoped=true&"
import script from "./TemplateInfoModal.vue?vue&type=script&lang=ts&"
export * from "./TemplateInfoModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9377b174",
  null
  
)

export default component.exports